import { get, post, patch } from 'store/http/httpAction';
import { setFields, resetCriteria, setCriteria, setLogic } from 'components/page/FilterCriteria__REFACTORED/flow/actions';
import { setAvailableFields, resetFilterValue, addToSelection } from 'components/page/ObjectFilter/components/FieldsSelection/flow/actions';
import { SELECT_OBJECTTYPE, SET_HISTORY } from './actionTypes';

export const selectObjectType = objectType => ({
  type: SELECT_OBJECTTYPE,
  payload: { objectType }
});

const setExportHistory = (historyData, pagination) => ({
  type: SET_HISTORY,
  payload: { historyData, pagination },
});

export const tryFetchColumns = objectType => dispatch =>
  get(`/admin/metadata/object/${objectType}`, {}, dispatch).then(data => {
    const main = data && data.main && _.isArray(data.main.data) ? data.main.data : [];
    const cstm = data && data.cstm && _.isArray(data.cstm.data) ? data.cstm.data : [];
    const columns = [...main, ...cstm];
    dispatch(setFields(columns));
    dispatch(setAvailableFields(columns));
  });

export const changeObject = objectType => dispatch => {
  dispatch(resetCriteria());
  dispatch(resetFilterValue());
  dispatch(selectObjectType(objectType));
  dispatch(tryFetchColumns(objectType));
};

export const fetchExportHistory = (per_page, page) => dispatch =>
  get('/admin/data-export-jobs', { per_page, page }, dispatch).then(data => {
    if (data && data.data && data.meta && data.meta.pagination) {
      dispatch(setExportHistory(data.data, data.meta.pagination));
    }
  });

export const exportData = value => (dispatch, getState) =>
  post('/admin/objects/export', value, dispatch).then(data => {
    if (data) {
      const store = getState();
      const { per_page, current_page } = store.setup.fileExport.exportHistory.pagination;
      dispatch(fetchExportHistory(per_page, current_page));
    }
  });

export const handleCopyExportHistory = data => async (dispatch, getState) => {
  const { object_type, export_setup_properties } = data;
  const { filters, condition_logic, selectors } = export_setup_properties;

  dispatch(resetCriteria());
  dispatch(resetFilterValue());
  await dispatch(tryFetchColumns(object_type));

  dispatch(selectObjectType(object_type));
  dispatch(setCriteria(filters));
  dispatch(setLogic(condition_logic || ''));

  const store = getState();
  const availableFields = (store && store.objectView && store.objectView.fields && store.objectView.fields.availableFields) || [];

  if (!_.isEmpty(availableFields)) {
    const selectedFields = [];
    availableFields.forEach(field => {
      if (_.includes(selectors, field.field_name)) {
        selectedFields.push(field);
      }
    });

    if (!_.isEmpty(selectedFields)) {
      dispatch(addToSelection(selectedFields));
    }
  }
};

export const handlePinExportHistory = (exportHistoryId, prePinStatus) => (dispatch, getState) => {
  if (!exportHistoryId) {
    return;
  }
  const url = prePinStatus ? `/admin/data-export-jobs/${exportHistoryId}/unpin` : `/admin/data-export-jobs/${exportHistoryId}/pin`;

  patch(url, {}, dispatch).then(data => {
    if (data) {
      const store = getState();
      const { per_page, current_page } = store.setup.fileExport.exportHistory.pagination;
      dispatch(fetchExportHistory(per_page, current_page));
    }
  });
};



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/flow/actions.js